import CnFormContainer from 'components/cn/CnFormContainer';

export default function CnMigrationFormPage() {
  // CN-specific contentful entry id
  const contentfulId = 'QiQyvage7qc0AgVODOhiX';
  
  // Optional: CN-specific success screen Contentful entry (title, item1, buttonText, buttonUrl, backgroundImage)
  const successContentfulId = '6QAym6echM4XNCKSzsFeHJ';
  
  return (
    <CnFormContainer
      contentfulId={contentfulId}
      successContentfulId={successContentfulId}
    />
  );
}
